import * as React from 'react';
/**
 *
 * Original name: Dropbox
Paper
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=4464%3A44
 *
 */
export const DropboxPaperLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 13.56 4.5 8.754 12 4l7.5 4.755L12 13.56Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "m7.98 12.726 4.02 2.55 4.02-2.55 3.48 2.206-7.5 4.804-7.5-4.804 3.48-2.206Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
